import { JiraFormItemType } from '../ProblemForm/constant';

interface OptionsType {
  label: string;
  value: string;
}

export const formatRadioOptions = (list: { id: number; name: string }[]) => {
  if (!list) {
    return [];
  }
  const options: OptionsType[] = [];
  list.forEach((item) => {
    options.push({
      label: item.name,
      value: String(item.id),
    });
  });
  return options;
};
export const formatScenario = (list: Array<string>) => {
  if (!list) {
    return [];
  }
  const options: OptionsType[] = [];
  list.forEach((item, index) => {
    options.push({
      label: item,
      value: item,
    });
  });
  return options;
};

export function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const colFormItem1: JiraFormItemType[] = [
  {
    label: '问题标题',
    name: 'topic',
    rules: true,
    rulesMessage: '问题标题不能为空',
    itemType: 'input',
    placeholder: '请输入问题标题',
  },
  {
    label: '是否为碰撞/剐蹭',
    name: 'isCrash',
    rules: true,
    rulesMessage: '请选择是否为碰撞/剐蹭',
    itemType: 'radio',
  },
  {
    label: '事故等级',
    name: 'accidentLevel',
    rules: true,
    rulesMessage: '事故等级不能为空',
    hidden: true,
    itemType: 'select',
    placeholder: '请选择事故等级',
  },
  {
    label: '事故分类',
    name: 'accidentType',
    rules: true,
    rulesMessage: '事故分类不能为空',
    hidden: true,
    itemType: 'select',
    placeholder: '请选择事故分类',
  },
  {
    label: '问题描述',
    name: 'description',
    rulesMessage: '问题描述不能为空',
    itemType: 'textArea',
    placeholder: '请输入问题描述',
  },
  {
    label: '事故负责人',
    name: 'follower',
    rules: true,
    rulesMessage: '事故负责人不能为空',
    hidden: true,
    itemType: 'input',
    placeholder: '请输入erp',
  },
];
export const colFormItem2: JiraFormItemType[] = [
  {
    label: '严重程度',
    name: 'severity',
    rules: true,
    rulesMessage: '严重程度不能为空',
    itemType: 'select',
  },
  {
    label: 'Rover版本',
    name: 'version',
    rules: true,
    rulesMessage: 'Rover版本不能为空',
    itemType: 'select',
  },
  {
    label: '发生时间',
    name: 'debugTime',
    rules: true,
    rulesMessage: '发生时间不能为空',
    itemType: 'custom',
  },
  {
    label: '上传截图',
    name: 'attachment',
    rules: false,
    rulesMessage: '',
    itemType: 'upload',
  },
];

export const jiraFormConfig = {
  data: colFormItem1,
  linkRules: [
    {
      fieldName: 'isCrash',
      linkFieldName: 'accidentLevel',
      type: ['visible'],
      visibleRule: {
        show: ['1'],
      },
    },
    {
      fieldName: 'isCrash',
      linkFieldName: 'accidentType',
      type: ['visible'],
      visibleRule: {
        show: ['1'],
      },
    },
    {
      fieldName: 'isCrash',
      linkFieldName: 'follower',
      type: ['visible'],
      visibleRule: {
        show: ['1'],
      },
    },
  ],
};
